import gsap from 'gsap';

const initPersonCards = (cards) => {
    cards.forEach((card) => {
        const button = card.querySelector('button');
        const content = card.querySelector('.person-card__bio');

        if (button) {
            gsap.set(content, {
                height: 0
            });

            button.addEventListener('click', () => {
                if (!card.classList.contains('is-active')) {
                    card.classList.add('is-active');
                    button.classList.add('is-active');
                    gsap.to(content, {
                        height: 'auto',
                        ease: 'power2.inOut'
                    });
                } else {
                    card.classList.remove('is-active');
                    button.classList.remove('is-active');
                    gsap.to(content, {
                        height: 0,
                        ease: 'power2.inOut'
                    });
                }
            });
        }
    });
};

export default initPersonCards;